import SiteHeader from "./SiteHeader";
import "../styles/components/TravelHotelPage.css";
import futureForwardImg from "../assets/future-forward.png";

const travelByAir = [
  {
    title: "Chicago O'Hare International Airport (ORD)",
    distance: "17 miles from venue",
    detail: "• 30–40 minutes by car",
  },
  {
    title: "Chicago Midway International Airport (MDW)",
    distance: "11 miles from venue",
    detail: "• 20–30 minutes by car",
  },
];

export default function TravelHotelPage() {
  const restaurantGuideHref = `${process.env.PUBLIC_URL}/Restaurant-guide.pdf`;

  return (
    <div className="travel">
      <SiteHeader />

      <main className="travel__main">
        <section className="travel__hero">
          <div className="container travel__heroInner">
            <div className="travel__heroKicker">
              2026 MOËT HENNESSY
              <br />
              DISTRIBUTOR CONFERENCE
            </div>
            <h1 className="travel__heroTitle">Travel &amp; Hotel</h1>
            <img
              src={futureForwardImg}
              alt="Future Forward"
              className="travel__heroImage"
            />
          </div>
        </section>

        <section className="travel__venue">
          <div className="container travel__venueInner">
            <div className="travel__sectionBar">Venue Location</div>
            <div className="travel__venueCard">
              <div className="travel__venueName">The Ritz-Carlton, Chicago</div>
              <div className="travel__venueSub">Water Tower Place</div>
              <div className="travel__venueAddress">160 E Pearson St, Chicago, IL 60611</div>
              <div className="travel__venueDivider" aria-hidden="true" />
              <div className="travel__mapFrame" aria-label="Map location">
                <iframe
                  title="The Ritz-Carlton, Chicago map"
                  src="https://www.google.com/maps?q=The%20Ritz-Carlton,%20Chicago%20160%20E%20Pearson%20St%20Chicago%20IL%2060611&output=embed"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="travel__gettingThere">
          <div className="container travel__gettingThereInner">
            <h2 className="travel__sectionTitle">Getting There</h2>
            <div className="travel__infoCard">
              <div className="travel__infoRow">
                <div className="travel__infoLabel">By Air</div>
                <div className="travel__infoContent">
                  {travelByAir.map((item) => (
                    <div className="travel__infoBlock" key={item.title}>
                      <div className="travel__infoTitle">{item.title}</div>
                      <div className="travel__infoDistance">{item.distance}</div>
                      <div className="travel__infoDetail">{item.detail}</div>
                    </div>
                  ))}
                </div>
              </div>
              {/* <div className="travel__infoRow">
                <div className="travel__infoLabel">By Train</div>
                <div className="travel__infoContent">
                  <div className="travel__infoTitle">CTA Red Line</div>
                  <div className="travel__infoDetail">
                    Chicago Avenue Station is a 5-minute walk from the venue
                  </div>
                </div>
              </div> */}
              <div className="travel__infoRow">
                <div className="travel__infoLabel">By Car / Rideshare</div>
                <div className="travel__infoContent">
                  <div className="travel__infoTitle">
                    Valet parking available at The Ritz-Carlton ($65/day)
                  </div>
                  <div className="travel__infoDetail">
                    Uber and Lyft readily available throughout Chicago
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="travel__resources" aria-label="Travel resources">
          <div className="container travel__resourcesInner">
            <h2 className="travel__sectionTitle">Restaurant Guide</h2>
            <div className="travel__resourceCard">
              <p className="travel__resourceText">
                Download the restaurant guide for recommendations near the venue.
              </p>
              <a className="travel__resourceButton" href={restaurantGuideHref} download>
                Download Restaurant Guide (PDF)
              </a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
